import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AuditRecordDto, AuditRecordLookupDto } from './audit.models';
import { environment } from 'src/environments/environment';

const PeriforApiEndpoint = `${environment.PeriforEndpoint}/api`;

@Injectable({ providedIn: 'root' })
export class AuditService {
  constructor(private http: HttpClient) {}

  getAuditList(): Observable<AuditRecordLookupDto[]> {
    return this.http.get<AuditRecordLookupDto[]>(`${PeriforApiEndpoint}/audit`);
  }

  getAuditRecord(id: number): Observable<AuditRecordDto> {
    return this.http.get<AuditRecordDto>(`${PeriforApiEndpoint}/audit/${id}`);
  }
}